import { AppState } from './state/AppState'
import React from 'react'
import { logDebug } from './debug/debugLogging'
import { getAnalyticsSeriesName } from './analytics/AnalyticsHelpers'

export function useAppStateAnalytics(appState: AppState) {
  const { userType, selectedProductSeries } = appState.userState

  React.useEffect(() => {
    if (userType !== null) {
      logDebug('useAppStateAnalytics', 'setting user type:', userType)
    }
  }, [userType])

  React.useEffect(() => {
    const series: 'Iconic' | 'Pro Series' = getAnalyticsSeriesName(selectedProductSeries) ?? 'Iconic'

    logDebug('useAppStateAnalytics', 'setting product series type:', series)
  }, [selectedProductSeries])
}